<template>
  <div>
    <div
      v-if="isLoading"
      class="bg-ontick-graphite-500 flex h-full transform cursor-pointer items-center justify-center space-x-4 rounded-lg py-8 transition hover:scale-105"
      @click="$emit('edit')"
    >
      <i v-html="$icons.loading"></i>
    </div>
    <div
      v-else-if="isEmpty && !isLoading"
      class="bg-ontick-graphite-500 flex h-full transform cursor-pointer items-center justify-center space-x-4 rounded-lg py-8 transition hover:scale-105"
      @click="$emit('edit')"
    >
      <svg
        class="text-ontick-steel-500"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28 0C20.5739 0 13.452 2.94999 8.20101 8.20101C2.94999 13.452 0 20.5739 0 28C0 35.4261 2.94999 42.548 8.20101 47.799C13.452 53.05 20.5739 56 28 56C35.4261 56 42.548 53.05 47.799 47.799C53.05 42.548 56 35.4261 56 28C56 20.5739 53.05 13.452 47.799 8.20101C42.548 2.94999 35.4261 0 28 0ZM24.5 38.5C24.5 39.4283 24.8687 40.3185 25.5251 40.9749C26.1815 41.6313 27.0717 42 28 42C28.9283 42 29.8185 41.6313 30.4749 40.9749C31.1313 40.3185 31.5 39.4283 31.5 38.5V31.5H38.5C39.4283 31.5 40.3185 31.1313 40.9749 30.4749C41.6313 29.8185 42 28.9283 42 28C42 27.0717 41.6313 26.1815 40.9749 25.5251C40.3185 24.8687 39.4283 24.5 38.5 24.5H31.5V17.5C31.5 16.5717 31.1313 15.6815 30.4749 15.0251C29.8185 14.3688 28.9283 14 28 14C27.0717 14 26.1815 14.3688 25.5251 15.0251C24.8687 15.6815 24.5 16.5717 24.5 17.5V24.5H17.5C16.5717 24.5 15.6815 24.8687 15.0251 25.5251C14.3688 26.1815 14 27.0717 14 28C14 28.9283 14.3688 29.8185 15.0251 30.4749C15.6815 31.1313 16.5717 31.5 17.5 31.5H24.5V38.5Z"
          fill="currentColor"
        />
      </svg>
      <span class="text-sm font-bold">{{ addMessage }}</span>
    </div>

    <div
      v-else-if="!isLoading && !isEmpty"
      class="bg-ontick-graphite-500 flex h-full flex-col justify-between space-y-4 rounded-lg p-4"
    >
      <div
        class="flex flex-col items-start justify-center space-y-2 lg:flex-row lg:space-y-0 lg:space-x-4"
      >
        <div
          v-html="img"
          class="bg-ontick-steel-500 flex h-12 w-16 items-center justify-center rounded-lg px-2"
        ></div>
        <div class="flex flex-grow flex-col">
          <span class="text-xl">{{ title }}</span>
          <span class="text-sm text-gray-400">{{ subtitle }}</span>
        </div>
      </div>
      <div
        class="flex flex-col items-center justify-between space-y-2 md:flex-row md:space-y-0"
      >
        <button class="text-ontick-blue-600 text-sm" @click="$emit('edit')">
          {{ editMessage }}
        </button>
        <button class="text-ontick-red-600 text-sm" @click="$emit('delete')">
          Deletar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    editMessage: {
      type: String,
    },
    isEmpty: {
      type: Boolean,
    },
    addMessage: {
      type: String,
    },
    isLoading: {
      type: Boolean,
    },
  },
};
</script>

<style></style>
